import { useTranslation } from 'react-i18next';
import whiteTelegramImg from '@/assets/images/whiteTelegram.svg';

const FixiedTgBtn = () => {
  const { t } = useTranslation();

  return (
      <a
        href='tg://resolve?domain=Dimmar_Ex_Manager&text=Здравствуйте!%20Пишу%20с%20сайта%20👋%0AПодскажите,%20пожалуйста,%20условия%20обмена'
        target='_blank'
        rel='noopener noreferrer'
        className='fixied-tg-btn'
      >
        <img src={whiteTelegramImg} alt="Telegram" width={15} height='auto'/>
        {t('companyInfo.firstBlockBtn')}
      </a>
  );
};

export default FixiedTgBtn;
